define("shared/components/shared/media-items/post-card", ["exports", "@ember/component", "@ember/object", "@ember/object/computed", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _computed, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <tr>
    <td>
      <Shared::ProfileAvatar @showDetails={{true}} @showPlatform={{true}} @socialProfile={{@post.socialProfile}} />
    </td>
    <td>
      {{this.postDisplayTime}}
    </td>
    <td class="u--text--right">
      {{#if @post.isInstagramStory}}
        <span class="u--text--light">
          {{t "shared_phrases.instagram_story"}}
        </span>
      {{else if this.postLocked}}
        <Shared::Ui::Button @onClick={{this.editPost}} @variant="mute">
          {{svg-jar "verified" class="o--icon o--icon--light u--m__r__xs"}}
          {{t "shared_words.posted"}}
        </Shared::Ui::Button>
  
      {{else}}
        <Shared::Ui::Button @onClick={{this.editPost}} @variant="outline" class="u--p__lr__md">
          {{t "shared_words.edit"}}
        </Shared::Ui::Button>
      {{/if}}
    </td>
  </tr>
  */
  {
    "id": "QOdV7KHK",
    "block": "[[[10,\"tr\"],[12],[1,\"\\n  \"],[10,\"td\"],[12],[1,\"\\n    \"],[8,[39,0],null,[[\"@showDetails\",\"@showPlatform\",\"@socialProfile\"],[true,true,[30,1,[\"socialProfile\"]]]],null],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"td\"],[12],[1,\"\\n    \"],[1,[30,0,[\"postDisplayTime\"]]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"td\"],[14,0,\"u--text--right\"],[12],[1,\"\\n\"],[41,[30,1,[\"isInstagramStory\"]],[[[1,\"      \"],[10,1],[14,0,\"u--text--light\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"shared_phrases.instagram_story\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"postLocked\"]],[[[1,\"      \"],[8,[39,3],null,[[\"@onClick\",\"@variant\"],[[30,0,[\"editPost\"]],\"mute\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,4],[\"verified\"],[[\"class\"],[\"o--icon o--icon--light u--m__r__xs\"]]]],[1,\"\\n        \"],[1,[28,[35,2],[\"shared_words.posted\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n\"]],[]],[[[1,\"      \"],[8,[39,3],[[24,0,\"u--p__lr__md\"]],[[\"@onClick\",\"@variant\"],[[30,0,[\"editPost\"]],\"outline\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,2],[\"shared_words.edit\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@post\"],false,[\"shared/profile-avatar\",\"if\",\"t\",\"shared/ui/button\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/media-items/post-card.hbs",
    "isStrictMode": false
  });
  let PostCardComponent = _exports.default = (_dec = (0, _computed.reads)('args.post.locked'), (_class = class PostCardComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "userConfig", _descriptor, this);
      _initializerDefineProperty(this, "postLocked", _descriptor2, this);
    }
    get postDisplayTime() {
      return moment.unix(this.args.post.scheduledTime).tz(this.userConfig.currentTimeZone.identifier).format('MMM DD, h:mm a');
    }
    editPost() {
      if (!this.args.post.isInstagramStory) {
        this.args.editPost(this.args.post.id);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "postLocked", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "editPost", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "editPost"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PostCardComponent);
});